import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/authentication/authContext';
import { consumeDemoTourIntent, exitDemoSession, getDemoSession } from '../../services/accountSetup/demoSession';
import { usePendingTourStore, tourLaunchIdentity } from '../onboarding/pendingTourStore';
import { useOnboardingStore } from '../onboarding/onboardingStore';
import { canAccessTour, getTour } from '../onboarding/tours';
import { ONBOARDING_DESKTOP_QUERY } from '../onboarding/constants';

export default function DemoBanner() {
  const { backendUser, user, accountSettings } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const hydrated = useOnboardingStore(state => state.hydrated);
  useEffect(() => {
    if (!backendUser?.demoContext || !hydrated || !getDemoSession()?.startTour) return;
    const tour = getTour('dashboard');
    consumeDemoTourIntent();
    if (!window.matchMedia(ONBOARDING_DESKTOP_QUERY).matches || !tour || !canAccessTour(tour, backendUser, accountSettings)) return;
    const destination = usePendingTourStore.getState().request(tour.id, tourLaunchIdentity(user?.id, backendUser.id, false), location.pathname, location.key);
    if (destination) navigate(destination, { replace: true });
  }, [backendUser, user?.id, hydrated, accountSettings, location.pathname, location.key, navigate]);
  if (!backendUser?.demoContext) return null;
  return <div className="flex shrink-0 items-center justify-between gap-3 bg-amber-100 dark:bg-amber-950 px-4 py-2 text-sm text-amber-950 dark:text-amber-100" role="status">
    <span>{t('accountSetup.demo.label')}</span>
    <button type="button" onClick={exitDemoSession} className="underline font-medium">{t('accountSetup.demo.backToSetup')}</button>
  </div>;
}
